import { LayoutType, withLayout } from 'hocs/with-layout';
import { StartOnboarding } from './start-onboarding';

const WrappedStartOnboarding = withLayout(
  LayoutType.WithOldNavOnly,
  StartOnboarding,
);

export { WrappedStartOnboarding as StartOnboarding };
